<template>
  <admin-layout
    :table-headers="headers"
    :table-items="categories"
    :edit-item="editCategory"
    :delete-item="deleteCategory"
    :search="search"
  >
    <template v-slot:header>
      <!-- alert -->
      <snackbar ref="alert" class="mb-5"></snackbar>
      <!--/alert-->

      <header-section
        header-title="Categories"
        v-model="search"
        :add-new-item="addCategory"
      >
        <template v-slot:addNew>
          <v-btn
            block
            color="primary"
            @click.stop="addCategory"
            :disabled="dialog"
            >Add New</v-btn
          >

          <v-dialog
            v-model="dialog"
            max-width="400px"
            v-if="addCategory"
            content-class="dialog-modal"
          >
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="validForm" lazy-validation>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model="selectedCategory.name"
                          :rules="formValidationRules"
                          label="Name*"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </header-section>
    </template>
  </admin-layout>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import AdminLayout from "@/layouts/AdminLayout.vue";
import HeaderSection from "@/components/HeaderSection.vue";
import Snackbar from "@/components/Snackbar.vue";

export default {
  /* eslint no-useless-escape: 0 */ // --> OFF
  components: {
    AdminLayout,
    Snackbar,
    HeaderSection
  },
  data: () => ({
    validForm: true,
    dialog: false,
    search: "",
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Slug", value: "slug", align: "left" },
      { text: "Created", value: "created_on", align: "left" },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    formValidationRules: [v => !!v || "This field is required"],
    selectedCategory: {},
    formTitle: "Add New Category",
    inEditMode: false,
    unsubscribeFromStoreAlerts: undefined
  }),
  computed: {
    categories() {
      return Object.values(this.$store.state.categories);
    }
  },
  methods: {
    ...mapActions([
      "retrieveCategoriesFromServer",
      "createCategory",
      "updateCategory",
      "destroyCategory"
    ]),
    ...mapMutations(["showLoading", "hideLoading"]),
    isFormValid() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      return this.$refs.form.resetValidation();
    },
    addCategory() {
      this.close();
      this.selectedCategory = {};
      this.openModal();
    },
    openModal() {
      this.dialog = true;
    },
    editCategory(category) {
      this.close();
      this.resetValidation();
      this.selectedCategory = category;
      this.inEditMode = true;
      this.formTitle = "Edit Category";
      this.openModal();
    },
    async deleteCategory(category) {
      this.$root
        .$confirm(
          "Delete Category",
          `Are you sure you wish the '${category.name}' category gone?`,
          {
            color: "red"
          }
        )
        .then(confirm => {
          if (confirm) {
            this.showLoading();
            this.destroyCategory(category);
            this.hideLoading();
          }
        });
    },
    customAlert(type, message) {
      this.$refs.alert.open(type, message);
    },
    close() {
      this.dialog = false;
      this.selectedLink = {};
      this.inEditMode = false;
      this.formTitle = "Add New Category";
      this.resetValidation();
    },
    save() {
      if (this.isFormValid()) {
        this.selectedCategory.slug = this.slugify(this.selectedCategory.name);
        const newCategory = Object.assign({}, this.selectedCategory);
        if (this.inEditMode) {
          this.showLoading();
          this.updateCategory(newCategory);
          this.hideLoading();
        } else {
          this.showLoading();
          this.createCategory(newCategory);
          this.hideLoading();
        }
        this.close();
      }
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
    }
  },
  created() {
    // subcribe to alert mutation
    this.unsubscribeFromStoreAlerts = this.$store.subscribe(
      (mutation, state) => {
        if (mutation.type == "updateAlert") {
          this.customAlert(state.alert.status, state.alert.message);
        }
      }
    );
  },
  destroyed() {
    // unsubscribe from alert mutation
    this.unsubscribeFromStoreAlerts();
  },
  async mounted() {
    this.showLoading();
    await this.retrieveCategoriesFromServer();
    this.hideLoading();
  }
};
</script>
